import ContentWrapper from 'Component/ContentWrapper';
import {
    BreadcrumbsComponent as SourceBreadcrumbsComponent,
} from 'SourceComponent/Breadcrumbs/Breadcrumbs.component';
import {Breadcrumb as BreadcrumbType} from 'Store/Breadcrumbs/Breadcrumbs.type';
import {ReactElement} from 'Type/Common.type';

/** @namespace Steinkrueger/Component/Breadcrumbs/Component */
export class BreadcrumbsComponent extends SourceBreadcrumbsComponent {
    render(): ReactElement {
        const { breadcrumbs } = this.props;
        const isVisible = breadcrumbs.length === 0 ? 'hidden' : 'visible';
        const isAccountPage = !!breadcrumbs.filter((item) => item.url === '/customer/account').length;

        if (this.shouldHideBreadcrumbs()) {
            return null;
        }

        return (
            <ContentWrapper
              mix={ { block: 'Breadcrumbs', elem: isVisible, mods: { isAccountPage } } }
              label={ __('Breadcrumbs (current location)...') }
            >
                <nav aria-label="Breadcrumbs navigation">
                    <ul
                      block="Breadcrumbs"
                      elem="List"
                      itemScope
                      itemType="http://schema.org/BreadcrumbList"
                    >
                        { (
                            breadcrumbs.length
                                ? this.renderBreadcrumbList(breadcrumbs)
                                : this.renderBreadcrumb({} as BreadcrumbType, 0)
                        ) }
                    </ul>
                </nav>
            </ContentWrapper>
        );
    }
}

export default BreadcrumbsComponent;
